import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'uppercase',
  borderRadius: '118px',
  textAlign: 'center',
  border: `1px solid ${theme.palette.darker}`,
  minWidth: '16.7vw',
  height: '6.5vh',
  width: '100%',
  letterSpacing: '3.38px',
  fontWeight: 'bold',
  [theme.breakpoints.up('md')]: {
    fontSize: 'clamp(1em, 1vw, 2em)',
  },
}))
